/**
 * Fill the data send to API
 * @param {string} wantedAmount
 * @param {string} conventionalRuptureRate
 * @param {string} operatingExpensesRate
 * @param {string} otherProvisionsRate
 * @param {string} pasRate
 * @param {string} portageFeesRate
 * @param {string} workingDays
 * @param {string} wantedAmountTypeSelected
 * @param {string} expensesAmount
 * @param {boolean} hasHealthMutual
 * @param {boolean} hasPaidVacation
 * @param {string} postalCode
 * @param {string} date
 */
export function fillRequestData(wantedAmount, conventionalRuptureRate, operatingExpensesRate, otherProvisionsRate, pasRate, portageFeesRate, workingDays, wantedAmountTypeSelected, expensesAmount, hasHealthMutual, hasPaidVacation, postalCode, date) {
    conventionalRuptureRate =
        parseAmount(conventionalRuptureRate) / 100;
    operatingExpensesRate =
        parseAmount(operatingExpensesRate) / 100;
    otherProvisionsRate = parseAmount(otherProvisionsRate) / 100;
    pasRate = parseAmount(pasRate) / 100;
    portageFeesRate = parseAmount(portageFeesRate) / 100;
    workingDays = parseAmount(workingDays);

    let period = workingDaysPeriod(wantedAmountTypeSelected);

    let requestsData = [
        commonRequestData(wantedAmount, conventionalRuptureRate, operatingExpensesRate, otherProvisionsRate, pasRate, portageFeesRate, workingDays, wantedAmountTypeSelected, expensesAmount, hasHealthMutual, hasPaidVacation, postalCode, date),
        commonRequestData(wantedAmount, conventionalRuptureRate, operatingExpensesRate, otherProvisionsRate, pasRate, portageFeesRate, workingDays, wantedAmountTypeSelected, expensesAmount, hasHealthMutual, hasPaidVacation, postalCode, date),
        commonRequestData(wantedAmount, conventionalRuptureRate, operatingExpensesRate, otherProvisionsRate, pasRate, portageFeesRate, workingDays, wantedAmountTypeSelected, expensesAmount, hasHealthMutual, hasPaidVacation, postalCode, date),
        commonRequestData(wantedAmount, conventionalRuptureRate, operatingExpensesRate, otherProvisionsRate, pasRate, portageFeesRate, workingDays, wantedAmountTypeSelected, expensesAmount, hasHealthMutual, hasPaidVacation, postalCode, date)
    ];

    const year = getValidatedDateYear(date);

    requestsData[0]['daysPerMonth'] = daysPerMonth(workingDays, false, year);
    requestsData[0]['hasMutuelle'] = false;

    requestsData[1]['daysPerMonth'] = daysPerMonth(workingDays, true, year);
    requestsData[1]['hasMutuelle'] = false;

    requestsData[2]['daysPerMonth'] = daysPerMonth(workingDays, false, year);
    requestsData[2]['hasMutuelle'] = true;

    requestsData[3]['daysPerMonth'] = daysPerMonth(workingDays, true, year);
    requestsData[3]['hasMutuelle'] = true;

    /*const currentYear = new Date().getFullYear();
    const hollidays = getFrenchHolidays(currentYear);

    console.log('currentYear', currentYear);
    console.log('getEasterDate', getEasterDate(currentYear));
    console.log('hollidays', hollidays);

    const nb = getWorkingDays(currentYear, hollidays);
    const nbTotal = getWorkingDays(currentYear);

    console.log('nb travaillés', nb);
    console.log('nb travaillés', nbTotal);*/

    return requestsData;
}

export function isTrueInvoiceAmount(amountType) {
    let hasTrueInvoiceAmount = false;
    switch (amountType) {
        case "Facturation mensuelle":
            hasTrueInvoiceAmount = true;
            break;
        case "Facturation annuelle":
            hasTrueInvoiceAmount = true;
            break;
        case "TJM":
            hasTrueInvoiceAmount = true;
            break;
    }
    return hasTrueInvoiceAmount;
}

export function setCalculatorWantedTypes(privateVersion = false) {
    let wantedAmountTypes = [
        "Salaire brut mensuel",
        "Salaire net mensuel",
        //"Salaire net annuel",
        //"TJM",
        "Salaire brut annuel",
    ];
    //if (privateVersion) {
    //    wantedAmountTypes = [...wantedAmountTypes, "Facturation mensuelle", "Facturation annuelle"];
    //}
    return wantedAmountTypes;
}

export function transformWantedType(type) {
    if ('b' === type) {
        return 'Salaire brut annuel';
    } else if ('c' === type) {
        return 'Salaire net mensuel';
    } else if ('d' === type) {
        return 'Salaire net annuel';
    } else if ('e' === type) {
        return "TJM";
    } else if ('f' === type) {
        return 'Facturation mensuelle';
    } else if ('g' === type) {
        return 'Facturation annuelle';
    }
    return 'Salaire brut mensuel'
}

export function simplifyWantedType(type) {
    if ('Salaire brut annuel' === type) {
        return 'b';
    } else if ('Salaire net mensuel' === type) {
        return 'c';
    } else if ('Salaire net annuel' === type) {
        return 'd';
    } else if ('TJM' === type) {
        return 'e';
    } else if ('Facturation mensuelle' === type) {
        return 'f';
    } else if ('Facturation annuelle' === type) {
        return 'g';
    }
    return 'a'
}

export async function getSimulator(api_url, requestsData, hasTrueInvoiceAmount, optimize, simulatorAll, simulatorMutual, simulatorVacation) {
    if (simulatorAll) {
        return await getSimulatorResults(api_url, requestsData, hasTrueInvoiceAmount, optimize);
    } else if (simulatorMutual && simulatorVacation) { //AA
        return await getSimulatorSimpleResults(api_url, requestsData, hasTrueInvoiceAmount, 3, optimize, true, true);
    } else if (simulatorMutual && !simulatorVacation) { //AS
        return await getSimulatorSimpleResults(api_url, requestsData, hasTrueInvoiceAmount, 2, optimize, true, false);
    } else if (!simulatorMutual && simulatorVacation) { //SA
        return await getSimulatorSimpleResults(api_url, requestsData, hasTrueInvoiceAmount, 1, optimize, false, true);
    } //SS
    return await getSimulatorSimpleResults(api_url, requestsData, hasTrueInvoiceAmount, 0, optimize, false, false);
}

export async function getSimulatorVacationDirect(api_url, requestsData, hasTrueInvoiceAmount, simulatorMutual) {
    if (simulatorMutual) { //AA
        return await getSimulatorVacationDirectResults(api_url, requestsData, hasTrueInvoiceAmount, 2);
    } //SS
    return await getSimulatorVacationDirectResults(api_url, requestsData, hasTrueInvoiceAmount, 0);
}

export async function getSimulatorDirect(api_url, requestsData, hasTrueInvoiceAmount, simulatorMutual) {
    if (simulatorMutual) { //AA
        return await getSimulatorDirectResults(api_url, requestsData, hasTrueInvoiceAmount, 2);
    } //SS
    return await getSimulatorDirectResults(api_url, requestsData, hasTrueInvoiceAmount, 0);
}

export async function getSimulatorSimpleWithAndWithoutVacation(api_url, requestsData, hasTrueInvoiceAmount, simulatorMutual) {
    const result = await getSimulator(
        api_url,
        requestsData,
        hasTrueInvoiceAmount,
        false,
        false,
        simulatorMutual,
        false,
    );
    const resultVacation = await getSimulator(
        api_url,
        requestsData,
        hasTrueInvoiceAmount,
        false,
        false,
        simulatorMutual,
        true,
    );
    const vacationDirect = await getSimulatorVacationDirect(
        api_url,
        requestsData,
        hasTrueInvoiceAmount,
        simulatorMutual
    );
    const withOutVacationDirect = await getSimulatorDirect(
        api_url,
        requestsData,
        hasTrueInvoiceAmount,
        simulatorMutual
    );

    return [
        vacationDirect[0],
        withOutVacationDirect[0],
        result[0],
        resultVacation[0],
    ];
}

export async function getSimulatorSimpleResults(api_url, requestsData, hasTrueInvoiceAmount, number, optimize, isMutual, isVacation) {
    let results;

    //number 0 SS
    //number 2 AS

    try {
        if (optimize) {
            const trav = requestsData[0]['travellingExpenses'];
            requestsData[0]['travellingExpenses'] = null;

            const resultsAlone = await Promise.all([
                getSimulatorResult(api_url, requestsData[0], hasTrueInvoiceAmount),
            ]);

            requestsData[0]['travellingExpenses'] = trav;

            delete requestsData[number]["grossSalary"];
            delete requestsData[number]["totalBaseGross"];
            delete requestsData[number]["netSalary"];
            //delete requestsData[number]["dailyRate"];
            requestsData[number]["dailyRate"] = resultsAlone[0]["dailyRate"];
            //requestsData[number]["invoiceAmount"] = resultsAlone[0]["invoiceAmount"];
        }

        if (isVacation) {

            let request = requestsData[0];
            if (isMutual) {
                request = requestsData[2];
            }

            const resultsAlone = await Promise.all([
                getSimulatorResult(api_url, request, hasTrueInvoiceAmount),
            ]);

            delete requestsData[number]["grossSalary"];
            delete requestsData[number]["totalBaseGross"];
            delete requestsData[number]["netSalary"];
            requestsData[number]["totalBaseGross"] = resultsAlone[0]["totalBaseGross"]
        }

        const resultsOptimize = await Promise.all([
            getSimulatorResult(api_url, requestsData[number], hasTrueInvoiceAmount),
        ]);

        results = [
            resultsOptimize[0],
        ];
    } catch (error) {
        alert("Une erreur s'est produite et a été remontée à l'équipe développement");
        throw (error);
    }

    return results;
}

export async function getSimulatorDirectResults(api_url, requestsData, hasTrueInvoiceAmount, number) {
    let results;

    //number 0 S
    //number 2 A

    try {

        /*let request = requestsData[number];

        const resultsAlone = await Promise.all([
            getSimulatorResult(api_url, request, hasTrueInvoiceAmount),
        ]);*/

        //delete requestsData[number+1]["grossSalary"];
        //delete requestsData[number+1]["totalBaseGross"];
        //delete requestsData[number+1]["netSalary"];
        ////delete requestsData[number+1]["dailyRate"];
        //delete requestsData[number+1]["totalBaseGross"]

        //requestsData[number]['daysPerMonth'] = daysPerMonthForYear(false, year);
        //requestsData[number+1]['daysPerMonth'] = daysPerMonthForYear(false, year);

        const resultsOptimize = await Promise.all([
            getSimulatorResult(api_url, requestsData[number], hasTrueInvoiceAmount),
            //getSimulatorResult(api_url, requestsData[number+1], hasTrueInvoiceAmount),
        ]);

        results = [
            resultsOptimize[0],
            //resultsOptimize[1],
        ];
    } catch (error) {
        alert("Une erreur s'est produite et a été remontée à l'équipe développement");
        throw (error);
    }

    return results;
}

export async function getSimulatorVacationDirectResults(api_url, requestsData, hasTrueInvoiceAmount, number) {
    let results;

    //number 0 S
    //number 2 A

    try {

        /*let request = requestsData[number];

        const resultsAlone = await Promise.all([
            getSimulatorResult(api_url, request, hasTrueInvoiceAmount),
        ]);*/

        delete requestsData[number + 1]["grossSalary"];
        delete requestsData[number + 1]["totalBaseGross"];
        delete requestsData[number + 1]["netSalary"];
        //delete requestsData[number+1]["dailyRate"];
        delete requestsData[number + 1]["totalBaseGross"]


        const resultsOptimize = await Promise.all([
            //getSimulatorResult(api_url, requestsData[number], hasTrueInvoiceAmount),
            getSimulatorResult(api_url, requestsData[number + 1], hasTrueInvoiceAmount),
        ]);

        results = [
            resultsOptimize[0],
            //resultsOptimize[1],
        ];
    } catch (error) {
        alert("Une erreur s'est produite et a été remontée à l'équipe développement");
        throw (error);
    }

    return results;
}

export async function getSimulatorResults(api_url, requestsData, hasTrueInvoiceAmount, optimize) {
    let results;

    try {
        if (hasTrueInvoiceAmount) {

            // sans mutuelle
            let resultsWoPaidVacation = await Promise.all([
                getSimulatorResult(api_url, requestsData[0], hasTrueInvoiceAmount),
                getSimulatorResult(api_url, requestsData[2], hasTrueInvoiceAmount),
            ]);

            if (!optimize) {
                // we want to keep grossSalary with or without Paid vacation
                requestsData[1]["grossSalary"] = resultsWoPaidVacation[0]["grossSalary"];
                requestsData[1]["dailyRate"] = null;
                requestsData[1]["invoiceAmount"] = 1000000;
                requestsData[3]["grossSalary"] = resultsWoPaidVacation[1]["grossSalary"];
                requestsData[3]["dailyRate"] = null;
                requestsData[3]["invoiceAmount"] = 1000000;
            }

            let resultsWPaidVacation = await Promise.all([
                getSimulatorResult(api_url, requestsData[1], false),
                getSimulatorResult(api_url, requestsData[3], false),
            ]);

            results = [
                resultsWoPaidVacation[1],
                resultsWPaidVacation[1],
                resultsWoPaidVacation[0],
                resultsWPaidVacation[0],
            ];

            requestsData = null;
            resultsWPaidVacation = null;
            resultsWoPaidVacation = null;

        } else {

            requestsData[0]['travellingExpenses'] = null;

            let resultsAlone = await Promise.all([
                getSimulatorResult(api_url, requestsData[0], hasTrueInvoiceAmount),
            ]);

            let hasTrueInvoiceAmountBis = hasTrueInvoiceAmount;

            if (optimize) {
                delete requestsData[0]["grossSalary"];
                delete requestsData[0]["totalBaseGross"];
                delete requestsData[0]["netSalary"];
                delete requestsData[1]["grossSalary"];
                delete requestsData[1]["totalBaseGross"];
                delete requestsData[1]["netSalary"];
                delete requestsData[2]["grossSalary"];
                delete requestsData[2]["totalBaseGross"];
                delete requestsData[2]["netSalary"];
                delete requestsData[3]["grossSalary"];
                delete requestsData[3]["totalBaseGross"];
                delete requestsData[3]["netSalary"];
                requestsData[1]["dailyRate"] = resultsAlone[0]["dailyRate"];
                requestsData[2]["dailyRate"] = resultsAlone[0]["dailyRate"];
                requestsData[3]["dailyRate"] = resultsAlone[0]["dailyRate"];
                requestsData[0]["dailyRate"] = resultsAlone[0]["dailyRate"];
                requestsData[0]['travellingExpenses'] = requestsData[1]["travellingExpenses"]

                hasTrueInvoiceAmountBis = true;
            }

            let resultsOther = await Promise.all([
                getSimulatorResult(api_url, requestsData[2], hasTrueInvoiceAmountBis),
                getSimulatorResult(api_url, requestsData[3], hasTrueInvoiceAmountBis),
                getSimulatorResult(api_url, requestsData[1], hasTrueInvoiceAmountBis),
                getSimulatorResult(api_url, requestsData[0], hasTrueInvoiceAmountBis),
            ]);

            results = [
                resultsOther[0],
                resultsOther[1],
                resultsOther[3],//resultsAlone[0],
                resultsOther[2],
            ];

            requestsData = null;
            resultsAlone = null;
            resultsOther = null;
        }
    } catch (error) {
        alert("Une erreur s'est produite et a été remontée à l'équipe développement");
        throw (error);

        return false;
    }
    return results;
}

async function getSimulatorResult(api_url, requestData, hasTrueInvoiceAmount) {
    let controller = new AbortController();
    setTimeout(() => controller.abort(), 20000);

    let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Request-Headers": "content-type",
        "Access-Control-Request-Method": "POST"
    };
    let result;

    let promise = await fetch(api_url, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
        signal: controller.signal,
    });
    if (!promise.ok) {
        throw Error(promise.statusText);
    }

    result = await promise.json();
    if (!hasTrueInvoiceAmount) {
        result["invoiceAmount"] = getInvoiceAmountFromResult(result);
        result["dailyRate"] = getInvoiceAmountFromResult(result) / result.daysPerMonth;
    }
    return result;
}

function parseAmount(value) {
    if (typeof value !== "string") {
        return value;
    }
    value = value.replace(",", ".");
    value = value.replace(/\s/g, "");

    return parseFloat(value);
}

/**
 Calcul le nombre de jour par mois à envoyer au simulateur
 ce nombre est calculé par rapport au nombre de jour travaillé et aux congés payés
 */
export function daysPerMonth(workingDays, hasPaidVacation, year = "2025") {
    if (hasPaidVacation) {
        //let yearlyVacationDays = 25
        //let paidVacationRatio =
        //    workingDays / 20 >= 1 ? 1 : workingDays / 20;
        //let paidVacationRatio = workingDays / 20;
        //workingDays = (20 - yearlyVacationDays / 12) * paidVacationRatio;

        //let paidVacationRatio = workingDays / 21;
        //workingDays = (21 - yearlyVacationDays / 12) * paidVacationRatio;

        //return daysPerMonthForYear(hasPaidVacation, year, "monthly");

        return daysPerMonthForYearFake(workingDays, hasPaidVacation, year, "monthly");
    }
    return workingDays;
}

export function daysPerMonthForYearFake(workingDays, hasPaidVacation, year = "2025", period = "monthly") {
    const days = (workingDays * 12) - 25;
    if ("monthly" !== period) {
        return days;
    }

    return days / 12;
}

/*
export function daysPerMonthForYear(hasPaidVacation, year = "2025", period = "monthly") {
    const years = getYears();
    const yearlyVacationDays = 25;
    let workingDaysParam = 300;
    let nonWorking = 2;
    let workingDays;

    Object.entries(years).forEach(([key, data]) => {
        if (key === year) {
            workingDaysParam = data.workingDays;
            nonWorking = data.nonWorking;
        }
    });

    workingDays = workingDaysParam - nonWorking;

    if (hasPaidVacation) {
        workingDays = (workingDaysParam - nonWorking - yearlyVacationDays);
    }

    if ("monthly" !== period) {
        return workingDays;
    }

    return workingDays / 12;
}
*/

/** définit la périodicité demandée */
function workingDaysPeriod(amountType) {
    if (amountType === "Salaire brut annuel" || amountType === "Salaire net annuel" || amountType === "Facturation annuelle") {
        return 'yearly';
    }
    return 'monthly';
}

function commonRequestData(wantedAmount, conventionalRuptureRate, operatingExpensesRate, otherProvisionsRate, pasRate, portageFeesRate, workingDays, wantedAmountTypeSelected, expensesAmount, hasHealthMutual, hasPaidVacation, postalCode, date) {

    let requestData = {
        conventionalRuptureRate: conventionalRuptureRate,
        //    daysPerMonth: daysPerMonth(workingDays, hasPaidVacation, period),
        //    hasMutuelle: hasHealthMutual,
        //invoiceAmount: 1000000,
        operatingExpenses: null,
        operatingExpensesRate: operatingExpensesRate,
        otherProvisionsRate: otherProvisionsRate,
        portageFeesRate: portageFeesRate,
        postalCode: postalCode,
        travellingExpenses: parseAmount(expensesAmount),
        pasRate: pasRate,
        //date: date.replace("-", "") + "15",
        date: date + "-15",
    };

    wantedAmount = parseAmount(wantedAmount);
    expensesAmount = parseAmount(expensesAmount);

    switch (wantedAmountTypeSelected) {
        case "Salaire brut mensuel":
            requestData["totalBaseGross"] = wantedAmount;
            break;
        case "Salaire brut annuel":
            requestData["totalBaseGross"] = parseAmount(wantedAmount / 12);
            requestData["travellingExpenses"] = parseAmount(expensesAmount / 12);
            break;
        case "Salaire net mensuel":
            requestData["netSalary"] = wantedAmount;
            break;
        case "Salaire net annuel":
            requestData["netSalary"] = parseAmount(wantedAmount / 12);
            requestData["travellingExpenses"] = parseAmount(expensesAmount / 12);
            break;
        case "TJM":
            requestData["dailyRate"] = wantedAmount;
            break;
        case "Facturation mensuelle":
            requestData["invoiceAmount"] = wantedAmount;
            break;
        case "Facturation annuelle":
            requestData["invoiceAmount"] = parseAmount(wantedAmount / 12);
            requestData["travellingExpenses"] = parseAmount(expensesAmount / 12);
            break;
    }

    return requestData;
}

function getInvoiceAmountFromResult(result) {
    if (!result) {
        return 0;
    }

    let expensesAmount = result.rawData.variables.travellingExpenses.value;
    let portageComissionRate = result.portageFeesRate;
    let operatingExpensesRate =
        result.rawData.variables.operatingExpensesRate.value;
    let conventionalRuptureRate =
        result.rawData.variables.conventionalRuptureRate.value;
    let otherProvisionsRate =
        result.rawData.variables.otherProvisionsRate.value;
    //let pasRate = result.rawData.variables.pasRate.value;
    let superGrossSalary = result.superGrossSalary;

    /*
       invoiceAmount-portageComissionAmount-operatingExpenses-otherProvisions-optimisableExpenses-conventionalRupture = superGrossSalary
       (invoiceAmount-portageComissionAmount)*(1-operatingExpensesRate-otherProvisionsRate-conventionalRuptureRate) = superGrossSalary
       invoiceAmount= superGrossSalary/((1-operatingExpensesRate-otherProvisionsRate-conventionalRuptureRate)*(1-portageComissionRate))

  */
    return (
        (superGrossSalary + expensesAmount) /
        ((1 - portageComissionRate) *
            (1 -
                operatingExpensesRate -
                otherProvisionsRate -
                conventionalRuptureRate))
    );
}

function getWorkingDays(year, holidays = []) {
    let workingDays = 0;

    for (let month = 0; month < 12; month++) {
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(year, month, day);
            const dayOfWeek = date.getDay();

            // Vérifie si c'est un jour de semaine (lundi à vendredi)
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                const formattedDate = formatDate(date);

                // Vérifie si le jour n'est pas férié
                if (!holidays.includes(formattedDate)) {
                    workingDays++;
                }
            }
        }
    }

    return workingDays;
}


function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function getFrenchHolidays(year) {
    const holidays = [];

    // Jours fériés fixes
    holidays.push(`${year}-01-01`); // Jour de l'An
    holidays.push(`${year}-05-01`); // Fête du Travail
    holidays.push(`${year}-05-08`); // Victoire 1945
    holidays.push(`${year}-07-14`); // Fête nationale
    holidays.push(`${year}-08-15`); // Assomption
    holidays.push(`${year}-11-01`); // Toussaint
    holidays.push(`${year}-11-11`); // Armistice 1918
    holidays.push(`${year}-12-25`); // Noël

    // Calcul des jours fériés relatifs à Pâques
    const easter = getEasterDate(year);

    holidays.push(formatDate(addDays(easter, 1)));  // Lundi de Pâques
    holidays.push(formatDate(addDays(easter, 39))); // Ascension
    //holidays.push(formatDate(addDays(easter, 50))); // Lundi de Pentecôte TRAVAILLER

    return holidays;
}

function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

function getEasterDate(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(year, month - 1, day); // retourne la date de Pâques
}

export function getValidatedDate(rawDate) {
    let now = new Date();
    let yearCurrent = now.getFullYear();
    let monthCurrent = String(now.getMonth() + 1).padStart(2, "0");
    // let dateInter = parseInt(yearCurrent+monthCurrent);

    if (!rawDate) {
        return yearCurrent + '-' + monthCurrent; // pas de paramètre
    }

    // Vérifie le format 4 chiffres - 2 chiffres (ex: 2025-03)
    // Note : on ne vérifie pas ici si l'année est raisonnable (ex: 0000)
    const regex = /^\d{4}-\d{2}$/;
    if (!regex.test(rawDate)) {
        return yearCurrent + '-' + monthCurrent; // format incorrect
    }

    // Sépare l'année et le mois
    const [year, month] = rawDate.split('-');
    // const yearNum = parseInt(year, 10);
    const monthNum = parseInt(month, 10);

    let dateInterRaw = parseInt(year + month);

    // Vérifie que le mois soit entre 1 et 12
    if (monthNum < 1 || monthNum > 12) {
        return yearCurrent + '-' + monthCurrent; // mois invalide
    }

    // Date à -4 mois
    const dateMinus = new Date(
        now.getFullYear(),
        now.getMonth() - 4,
        now.getDate()
    );

    // Date à +4 mois
    const datePlus = new Date(
        now.getFullYear(),
        now.getMonth() + 4,
        now.getDate()
    );

    let yearMinus = dateMinus.getFullYear();
    let monthMinus = String(dateMinus.getMonth() + 1).padStart(2, "0");
    let dateInterMinus = parseInt(yearMinus + monthMinus);

    let yearPlus = datePlus.getFullYear();
    let monthPlus = String(datePlus.getMonth() + 1).padStart(2, "0");
    let dateInterPlus = parseInt(yearPlus + monthPlus);

    if (dateInterRaw <= dateInterMinus) {
        return yearCurrent + '-' + monthCurrent;
    }

    if (dateInterRaw >= dateInterPlus) {
        return yearCurrent + '-' + monthCurrent;
    }

    return rawDate;
}

export function getValidatedDateYear(rawDate) {
    let now = new Date();
    let yearCurrent = now.getFullYear();
    let monthCurrent = String(now.getMonth() + 1).padStart(2, "0");
    // let dateInter = parseInt(yearCurrent+monthCurrent);

    if (!rawDate) {
        return yearCurrent; // pas de paramètre
    }

    // Vérifie le format 4 chiffres - 2 chiffres (ex: 2025-03)
    // Note : on ne vérifie pas ici si l'année est raisonnable (ex: 0000)
    const regex = /^\d{4}-\d{2}$/;
    if (!regex.test(rawDate)) {
        return yearCurrent; // format incorrect
    }

    // Sépare l'année et le mois
    const [year, month] = rawDate.split('-');
    // const yearNum = parseInt(year, 10);
    const monthNum = parseInt(month, 10);

    let dateInterRaw = parseInt(year + month);

    // Vérifie que le mois soit entre 1 et 12
    if (monthNum < 1 || monthNum > 12) {
        return yearCurrent; // mois invalide
    }

    // Date à -4 mois
    const dateMinus = new Date(
        now.getFullYear(),
        now.getMonth() - 4,
        now.getDate()
    );

    // Date à +4 mois
    const datePlus = new Date(
        now.getFullYear(),
        now.getMonth() + 4,
        now.getDate()
    );

    let yearMinus = dateMinus.getFullYear();
    let monthMinus = String(dateMinus.getMonth() + 1).padStart(2, "0");
    let dateInterMinus = parseInt(yearMinus + monthMinus);

    let yearPlus = datePlus.getFullYear();
    let monthPlus = String(datePlus.getMonth() + 1).padStart(2, "0");
    let dateInterPlus = parseInt(yearPlus + monthPlus);

    if (dateInterRaw <= dateInterMinus) {
        return yearCurrent;
    }

    if (dateInterRaw >= dateInterPlus) {
        return yearCurrent;
    }

    return year;
}